import { Form } from '@/common/form/Form';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { FormFields } from '../form/rendering/FormFields';
import { DialogFormFieldContainer } from './DialogFormFieldContainer';

export const ExportDialog = ({ data, closeDialog }) => {
  const rsrc = useRsrc();
  const module = useModuleFromRoute();

  const [pluginInfos, setPluginInfos] = useState();
  const [selectedPluginInfo, setSelectedPluginInfo] = useState(null);

  const formRef = useRef();

  useEffect(() => {
    const reqParam = {
      uiType: data.uiType,
      entity: data.entity,
    };

    rsrc.data(module, 'EXPORT_PLUGIN_INFO_DATA_PLUGIN', reqParam).then((res) => {
      setPluginInfos(res);
      if (res.length > 0) setSelectedPluginInfo(res[0]);
    });
  }, []);

  // Assign a default value to the name
  useEffect(() => {
    if (!selectedPluginInfo) return;
    formRef.current.assignFormValues({
      name: data.displayName ? data.displayName + ' ' + selectedPluginInfo.name : selectedPluginInfo.name,
    });
  }, [selectedPluginInfo]);

  const submit = () => {
    if (formRef.current.hasErrorState()) {
      formRef.current.touchAll();
      return;
    }
    const sanitizedFieldDefs = data.fieldDefs?.map((fd) => {
      const { component, validators, ...rest } = fd;
      return rest;
    });

    data.fieldDefs = sanitizedFieldDefs;

    const formValues = formRef.current.formValues;
    const exportReq = {
      ...data,
      ...formValues,
    };

    const job = {
      code: selectedPluginInfo.code.replace('_EXPORT_PLUGIN', ''),
      name: formValues.name,
      module: module,
      entity: data.entity,
      entityId: data.entityId,
      rsrcCode: selectedPluginInfo.code,
      reqParamJson: JSON.stringify(exportReq),
      cat: 'EXPORT',
      queueExempt: true,
    };

    rsrc.save('skdr', 'JOB', job).then((job) => {
      rsrc.start(job.id);
      closeDialog();
    });
  };

  return (
    <Dialog onClose={() => closeDialog()} open fullWidth>
      <DialogTitle>Export</DialogTitle>
      <DialogContent>
        {pluginInfos && (
          <FormControl fullWidth sx={{ marginBottom: '1rem' }}>
            <InputLabel>Export</InputLabel>
            <Select value={selectedPluginInfo} onChange={(event) => setSelectedPluginInfo(event.target.value)}>
              {pluginInfos.map((pluginInfo) => (
                <MenuItem key={pluginInfo.code} value={pluginInfo}>
                  {pluginInfo.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        <Form
          key={selectedPluginInfo?.code} // Reset form when plugin changes to enable defaultValues to work
          ref={formRef}
        >
          <FormFields fieldDefs={selectedPluginInfo?.fieldDefs} container={DialogFormFieldContainer} />
        </Form>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialog} color="secondary" variant="outlined">
          Cancel
        </Button>
        <Button onClick={submit} color="primary" variant="contained">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};
